import script from "./MembershipNew.vue?vue&type=script&setup=true&lang=js"
export * from "./MembershipNew.vue?vue&type=script&setup=true&lang=js"

import "./MembershipNew.vue?vue&type=style&index=0&id=05303aed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05303aed"]])

export default __exports__